import apiClient from '../utils/apiClient';

export interface User {
  id: number;
  entraId: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  organizationId: number;
  roleId: number;
  organization: {
    id: number;
    name: string;
    description: string;
  };
  role: {
    id: number;
    name: string;
    description: string;
  };
}

export interface Role {
  id: number;
  name: string;
  description: string;
}

export interface Organization {
  id: number;
  name: string;
  description: string;
}

export interface InviteUserDTO {
  email: string;
  firstName: string;
  lastName: string;
  roleId: number;
  organizationId: number;
  redirectUrl: string;
}

export interface UpdateUserDTO {
  roleId?: number;
  organizationId?: number;
  isActive?: boolean;
}

// Get the current authenticated user
export const getCurrentUser = async (): Promise<User> => {
  return apiClient.get<User>('api/User/me');
};

// Get all users (admin only)
export const getAllUsers = async (): Promise<User[]> => {
  return apiClient.get<User[]>('api/User');
};

// Get a specific user by ID (admin only)
export const getUserById = async (id: number): Promise<User> => {
  return apiClient.get<User>(`api/User/${id}`);
};

// Invite a new user with password reset link (admin only)
export const inviteUser = async (user: InviteUserDTO): Promise<User> => {
  console.log('userService.inviteUser called with:', user);
  try {
    const result = await apiClient.post<User>('api/User/invite', user);
    console.log('userService.inviteUser success:', result);
    return result;
  } catch (error) {
    console.error('userService.inviteUser error:', error);
    throw error;
  }
};

// Update an existing user (admin only)
export const updateUser = async (id: number, updates: UpdateUserDTO): Promise<User> => {
  return apiClient.patch<User>(`api/User/${id}`, updates);
};

// Get all available roles (admin only)
export const getAllRoles = async (): Promise<Role[]> => {
  return apiClient.get<Role[]>('api/User/roles');
};

// Get all available organizations (admin only)
export const getAllOrganizations = async (): Promise<Organization[]> => {
  return apiClient.get<Organization[]>('api/User/organizations');
};
